<ng-container *ngIf="isStep('insertion-list')">
  <rt-redactor-inserts-dropdown-item
    [iconName]="'list'"
    [heading]="'app.redactor_inserts.questionnaires.dropdown.heading' | translate"
    [subheading]="'app.redactor_inserts.questionnaires.dropdown.subheading' | translate"
    [link]="'settings/questionnaires'"
    [featureGuard]="GuardedFeatures.Questionnaires"
    [selected]="selected"
    (stepInside)="goSecondStep()"
  >
  </rt-redactor-inserts-dropdown-item>
</ng-container>

<ng-container *ngIf="isStep('questionnaires-templates')">
  <div #container (keydown)="handleKeyDown($event)" tabindex="0" class="wrapper">
    <rt-redactor-inserts-dropdown-header
      [hasBackAction]="hasBackAction"
      [hasSearch]="state.questionnairesTemplates.length > 5"
      [searchQuery]="state.searchQuery"
      [searchPlaceholder]="'app.common.placeholders.search.questionnaires.other' | translate"
      [label]="'app.redactor_inserts.questionnaires.dropdown.heading' | translate"
      [hasSettings]="!!state.questionnairesTemplates.length"
      (searchQueryChange)="onSearchQueryChange($event)"
      (goBack)="goBack()"
      (goToSettings)="goToSettings('/settings/questionnaires')"
      (focusChanges)="onFocusChanges($event)"
      (closeDropdown)="closeDropdown.emit()"
    >
    </rt-redactor-inserts-dropdown-header>

    <ng-container *ngIf="!insideTemplate">
      <ng-container *ngIf="state.questionnairesTemplateGroups.length > 0">
        <div class="group-container">
          <div
            *ngFor="
              let questionnairesTemplateGroup of state.questionnairesTemplateGroups;
              let lastGroup = last;
              trackBy: groupsTrackByFn
            "
          >
            <rt-dropdown-header [isSubheading]="true">
              {{ questionnairesTemplateGroup.groupName }}
            </rt-dropdown-header>
            <rt-dropdown-item
              *ngFor="
                let template of questionnairesTemplateGroup.groupedQuestionnairesTemplates;
                let lastItem = last;
                trackBy: templatesTrackByFn
              "
              #eleRef
              [highlighted]="isSelected(template, eleRef)"
              [noDivider]="lastGroup && lastItem"
              (click)="questionnairesTemplateChoose(template)"
            >
              {{ template.name }}
            </rt-dropdown-item>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="state.questionnairesTemplates.length === 0 && !state.searchQuery.length">
        <rt-empty-state
          [title]="'app.redactor_inserts.questionnaires.dropdown.empty_state_title' | translate"
          [desc]="'app.redactor_inserts.questionnaires.dropdown.empty_state_desc' | translate"
          variant="small"
          class="empty-state"
          padding-lr
        >
          <rt-button variant="primary" (click)="navigateToQuestionnaires()">
            {{ 'app.redactor_inserts.questionnaires.dropdown.empty_state_button' | translate }}
          </rt-button>
        </rt-empty-state>
      </ng-container>

      <ng-container
        *ngIf="state.questionnairesTemplateGroups.length === 0 && state.searchQuery.length"
      >
        <rt-empty-state
          [title]="'app.redactor_inserts.questionnaires.dropdown.no_filtered_title' | translate"
          [desc]="'app.redactor_inserts.questionnaires.dropdown.no_filtered_desc' | translate"
          variant="small"
          class="empty-state"
          padding-lr
        >
        </rt-empty-state>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="insideTemplate">
      <ng-container *ngTemplateOutlet="insideTemplate"> </ng-container>
    </ng-container>
  </div>
</ng-container>
